<template>
    <div class="myGift">
        <div class="page_top">
            <div class="title" @click="back()"><i class="icon"></i>我的獎品</div>
        </div>
        <div class="page_padding" v-infinite-scroll="getMemberGifts" v-loading="loading"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-empty v-if="gift_empty" description="尚未有獎品唷!"></el-empty>
            <el-row type="flex" justify="center" style="margin-top: 15px;margin-bottom: 15px"
                    v-for="(item ,index) in list"
                    :key="index">
                <div class="card">
                    <div class="icon" style="color: #E6A23C">
                        <i class="el-icon-shopping-bag-1"></i><span>贈品</span>
                    </div>
                    <div class="gift-content">
                        <span class="gift-name">{{item.name}}</span>
                        <el-button class="gift-button" type="success" plain @click="openGift(item.sn)">使用</el-button>
                    </div>
                    <el-divider content-position="right">中獎日期:{{item.createdAt}}</el-divider>
                </div>
            </el-row>

            <el-dialog custom-class="dialog" :visible.sync="dialogVisible" title="贈品" :fullscreen="true" >
                <i class="el-icon-loading dialog_loading"></i>
                <el-empty description="資料讀取中..." class="dialog_content" style="width: 100%"></el-empty>
                <iframe v-show="ifram_show" class="mainframe" frameborder="0" :src="ifram_url" id="mainframe" @load="showIframe()" />
            </el-dialog>
            <el-backtop target=".page_padding" :bottom="150"></el-backtop>
        </div>
        <MENU/>

    </div>
</template>


<script>
    import FN from '@/components/fn'
    import MENU from '@/components/menu.vue'
    import {mapActions} from 'vuex'


    export default {
        components: {
            MENU
        },
        mixins: [FN],
        data() {
            return {
                dialogVisible: false,
                list: [],
                ids: [],
                gift_name: "全家100元禮券",
                lottery_date: "2021-12-31",
                lottery_date_title: "中獎日期",
                page: 1,
                loading: true,
                gift_empty: true,
                ifram_url: "",
                ifram_show:false,
            }
        },
        mounted() {
        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            getMemberGifts() {
                this.FETCH({
                    key: 'GET_MEMBER_GIFTS',
                    page: this.page
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.handleSubmit)
                    } else {
                        this.handleResponse(res)
                    }
                })
            },
            handleResponse(res) {
                if (!+res.code) {
                    for (var i = 0; i < res.pagination.data.length; i++) {
                        this.gift_empty = false;
                        var id = res.pagination.data[i].id
                        if (!this.ids.includes(id)) {
                            this.ids.push(res.pagination.data[i].id);
                            this.list.push(res.pagination.data[i]);
                        }
                    }
                    if (this.page < res.pagination.last_page) {
                        this.page += 1;
                    }
                } else {
                    this.$confirm(res.message, {
                        showCancelButton: false,
                        type: 'error'
                    })
                }
                this.loading = false
            }, openGift(url) {
                if(url != this.ifram_url ){
                    this.ifram_show=false;
                    this.ifram_url = url;
                }
                this.dialogVisible = true;
            }, back() {
                const {href} = this.$router.resolve({name: 'SetList'})
                window.open(href, '_self')
            },showIframe(){
                this.ifram_show=true
            }


        },

    }
</script>
